import { render, staticRenderFns } from "./GCASettings.vue?vue&type=template&id=36b7aec0"
import script from "./GCASettings.vue?vue&type=script&lang=js"
export * from "./GCASettings.vue?vue&type=script&lang=js"
import style0 from "./GCASettings.vue?vue&type=style&index=0&id=36b7aec0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports